import { STATUSES } from 'enumerations';



export const TABLE_STATUS = STATUSES.slice(0, 3);